import { withLazyValueCapability } from "./lazyValueCapability";

const hocs = [withLazyValueCapability];

/**
 * Wraps a component definition with common capabilities.
 * @param {Function} WrappedComponet - React component to wrap
 * @param {Object} options - chained to component capabilities
 * @returns {Function} the component wrapped with additional capabilities
 */
export function withComponentCapabilities(WrappedComponent, options = {}) {
    return hocs.reduceRight((Comp, hoc) => hoc(Comp, options), WrappedComponent);
};
